"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var toolbar_1 = require("@syl-editor/lib/dist/lib/modules/toolbar");
var select_1 = require("./tools/select");
var button_1 = require("./tools/button");
var divider_1 = require("./tools/divider");
var tools_1 = require("./tools");
var noop = function () { };
exports.noop = noop;
var ToolDisplay;
(function (ToolDisplay) {
    ToolDisplay["HORIZON"] = "horizon";
    ToolDisplay["VERTICAL"] = "vertical";
})(ToolDisplay || (ToolDisplay = {}));
exports.ToolDisplay = ToolDisplay;
// 检查一下选中的内容里面是不是都包含这个样式
var checkFormatAcross = function (editor, formatName) {
    var hasFormat = true;
    var isTable = false;
    var isNode = Boolean(editor.view.state.schema.nodes[formatName]);
    editor.nodesBetween(function (node) {
        // 没有这个样式，应该应用样式
        if (!hasFormat)
            return false;
        if (node.type.spec.tableRole)
            isTable = true;
        if (isTable)
            return false;
        // 节点只关心顶层节点
        if (isNode && node.isBlock && !node.type.spec.isolating) {
            hasFormat = node.type.name === formatName;
            return false;
        }
        else if (node.isText) {
            hasFormat = node.marks.some(function (mark) { return mark.type.name === formatName; });
        }
    });
    return isTable || hasFormat;
};
var getGroupKey = function (data) {
    return data.content.map(function (i) { return i.name; }).join('|');
};
exports.getGroupKey = getGroupKey;
var getToolDisplay = function (type) {
    return type ? ToolDisplay.HORIZON : ToolDisplay.VERTICAL;
};
exports.getToolDisplay = getToolDisplay;
// 获取按钮点击事件，优先取controller配置的，默认setFormat
var getHandler = function (toolbar, callback) {
    return function (editor, name, attrs) {
        var _a;
        if (!toolbar)
            return noop;
        if (toolbar.handler) {
            toolbar.handler(editor, name, attrs);
        }
        else {
            // false的情况再判断一下选区内是不是都是包含相应的样式
            editor.setFormat((_a = {},
                _a[name] = attrs
                    ? attrs
                    : editor.getFormat()[name]
                        ? checkFormatAcross(editor, name)
                            ? false
                            : true
                        : attrs,
                _a));
        }
        callback && callback(editor, name);
    };
};
exports.getHandler = getHandler;
var stamp = 1;
var keys = new Map();
var uuid = function () { return "" + stamp++; };
exports.uuid = uuid;
// 用于渲染内置的按钮
var renderSylButton = function (_a) {
    var activeFormat = _a.activeFormat, content = _a.content, editor = _a.editor, option = _a.option, depth = _a.depth, toolbarType = _a.toolbarType, selectProps = _a.selectProps, buttonProps = _a.buttonProps, _b = _a.extra, extra = _b === void 0 ? {} : _b;
    var _c = content.name, name = _c === void 0 ? '' : _c, type = content.type, toolbar = content.toolbar, tooltip = content.tooltip, showName = content.showName;
    var onToolClick = option.onToolClick, tipDirection = option.tipDirection, tipDistance = option.tipDistance, menuDirection = option.menuDirection, menuDistance = option.menuDistance;
    var active = Boolean(activeFormat[name]);
    var prop = {
        name: name,
        toolbar: toolbar,
        editor: editor,
        showName: showName,
        active: active,
        tooltip: tooltip,
        toolbarType: toolbarType,
        tipDirection: tipDirection,
        tipDistance: tipDistance,
        attrs: active ? activeFormat[name] : false,
        display: getToolDisplay(depth),
        handler: getHandler(toolbar, onToolClick)
    };
    var trigger = option.trigger;
    if (toolbar) {
        if (toolbarType === 'inline' && toolbar.inline && toolbar.inline.trigger) {
            trigger = toolbar.inline.trigger;
        }
        else if (toolbar.trigger) {
            trigger = toolbar.trigger;
        }
    }
    var groupKey = extra.groupKey, config = extra.config;
    switch (type) {
        case toolbar_1.TOOL_TYPE.DIVIDER:
            return react_1.default.createElement(divider_1.Divider, { key: uuid() });
        case toolbar_1.TOOL_TYPE.SELECT:
        case toolbar_1.TOOL_TYPE.DROPDOWN:
            return (react_1.default.createElement(select_1.SelectForToolbar, __assign({ key: type + "-" + name, trigger: trigger, type: type, display: prop.display, menuDirection: menuDirection, menuDistance: menuDistance, groupKey: groupKey }, prop, selectProps, config)));
        case toolbar_1.TOOL_TYPE.BUTTON:
        default:
            return (react_1.default.createElement(button_1.ButtonForToolbar, __assign({ key: "button-" + name }, prop, buttonProps, config)));
    }
};
exports.renderSylButton = renderSylButton;
// 渲染下拉菜单按钮
var renderMoreToolButton = function (_a) {
    var editor = _a.editor, renderMenu = _a.renderMenu, option = _a.option, content = _a.content, toolbarType = _a.toolbarType, groupKey = _a.groupKey, depth = _a.depth;
    var menuDistance = option.menuDistance, menuDirection = option.menuDirection, trigger = option.trigger, tipDirection = option.tipDirection, tipDistance = option.tipDistance;
    var icon = content.icon, contentItems = content.content, tooltip = content.tooltip, _b = content.name, name = _b === void 0 ? '' : _b, cTrigger = content.trigger;
    var key = keys.get(content);
    if (!key) {
        key = uuid();
        keys.set(content, key);
    }
    return (react_1.default.createElement(tools_1.MoreForToolbar, { trigger: cTrigger || trigger, key: key, toolbarType: toolbarType, name: name, icon: icon, editor: editor, display: getToolDisplay(depth), tooltip: tooltip, menuDistance: content.menuDistance || menuDistance, groupKey: groupKey, menuDirection: content.menuDirection || menuDirection, tipDirection: content.tipDirection || tipDirection, tipDistance: content.tipDistance || tipDistance, renderMenu: function () { return renderMenu(contentItems, depth); } }));
};
exports.renderMoreToolButton = renderMoreToolButton;
//# sourceMappingURL=utils.js.map